(() => {
    // going from index 0, searches after and equals 3
    let minWords = 2;
    let searchFormField = document.querySelector('#searchFormField');
    let searchForm = document.querySelector('#searchForm');
    let datalist = document.querySelector('.autocomplete--box');

    const initStateReady = () => {
        // event listener
        if (searchFormField) {
            searchFormField.addEventListener('input', renderAutoSuggestion);
        }
    };

    const renderAutoSuggestion = () => {
        if (searchFormField.value.length >= minWords) {
            doSearch(searchFormField.value, searchFormField.getAttribute('data-autocomplete-source'));
        }
    };

    const submitForm = () => {
        searchForm.submit();
    };

    const doSearch = (term, uri) => {
        // add term param at uri
        uri += '&term=' + encodeURIComponent(term);

        fetch(uri, {
            method: 'GET',
        })
            .then(function (response) {
                if (response.ok) {
                    return response.json();
                }
            })
            .then(function (data) {
                initAutosuggestion(data.completions, term);
            });
    };

    const initAutosuggestion = (data, term) => {
        resetDatalist();

        // Create list options
        for (let wizard of data) {
            // bypass output if result equals input
            if (wizard !== term) {
                const li = document.createElement('li');
                li.classList.add('autocomplete--box--li');
                li.textContent = wizard;
                li.addEventListener('click', function (event) {
                    resetDatalist();
                    searchFormField.value = li.textContent;
                    submitForm();
                });

                // Add options to datalist
                datalist.appendChild(li);
            }
        }
    };

    const resetDatalist = () => {
        // reset list
        datalist.innerHTML = '';
    };

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') return;

        initStateReady();
    });
})();
